<template>
  <router-view />
</template>

<script>
export default {
  name: 'Tpl',
}
</script>
